import {Component, Inject, OnInit, ViewChild,} from '@angular/core';

import {ActivatedRoute, Router} from '@angular/router';

import {AlertService, AuthenticationService, UserService,} from '../../_services/index';

import {MatDialog, MatDialogConfig,} from '@angular/material/dialog';

import {LoginHelper, Role} from '../../helpers';
import {DOCUMENT} from "@angular/common";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {AssessmentService} from "../../_services/assessment.service";
import {AssessmentUserAnswersComponent} from "../assessmentUserAnswers/assessmentUserAnswers.component";
import {MessageComponent} from "../message";
import {MatStepper} from "@angular/material/stepper";
import { Constants } from '../../helpers/constants';

@Component({
    standalone: false,
  selector: "assessment-component",
  templateUrl: 'assessment.component.html',
  styleUrls: ['./assessment.component.scss'],
})

export class AssessmentComponent implements OnInit {
  @ViewChild('stepper')
  stepper: MatStepper;
  api = window.location.origin;
  quizForms: FormGroup[] = [];
  topForm: FormGroup;
  items: any[];
  assessmentId: number = null;
  assessments = [];
  canEdit: boolean = false;
  quiz: any;
  tenantName: string;
  answersId: number = 0;
  answers: any = {};
  files: any = {};
  token = LoginHelper.getFileToken();
  canParticipate: boolean = false;
  isHidden = {};
  isValidated = false;
  notRequired = {};
  constants = Constants;

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public alertService: AlertService,
    public authenticationService: AuthenticationService,
    public userService: UserService,
    public dialog: MatDialog,
    @Inject(DOCUMENT) public document: any,
    public _formBuilder: FormBuilder,
    public assessmentService: AssessmentService) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;

  }

  initForm() {
    this.quizForms = [];
    if (this.quiz) {
      this.topForm = this._formBuilder.group({
        completionName: [this.quiz.completionName, [Validators.required]]
      });
      if (this.quiz.isCompletionNameLocked) {
        this.topForm.controls.completionName.disable();
      }
      this.quiz.quizData.steps.map((step, stepId) => {
        const controls = {};
        step.items.map((item, itemId) => {
            if (item.type == 'question') {
              if (item.hasPleaseExplain) {
                controls['r' + stepId + "_" + itemId + '_pleaseexplain'] = [''];
              }
              if (item.multiple) {
                item.answers.map((answer, answerId) => {
                  controls['r' + stepId + "_" + itemId + "_" + answerId] = [null]
                })
              } else {
                controls['r' + stepId + "_" + itemId] = (item.answers && item.answers.length) ? [null, Validators.required] : [null];
                this.notRequired['r' + stepId + "_" + itemId] = !(item.answers && item.answers.length);
              }

            } else if (item.type == 'textQuestion') {
              if (item.multiple) {
                const group = {};
                group['r' + stepId + "_" + itemId + '_0'] = ['', Validators.required];
                controls['r' + stepId + "_" + itemId] = this._formBuilder.group(group);
                controls['r' + stepId + "_" + itemId].list = [0];
              } else {
                controls['r' + stepId + "_" + itemId] = [null, Validators.required]
              }
            } else if (item.type === 'yesNoQuestion') {
              controls[`r${stepId}_${itemId}`] = [null];
              item.answers.forEach((answer, answerId) => {
                controls[`r${stepId}_${itemId}_${answerId}_pleaseexplain`] = [''];
              });
            }
          });
          if (stepId === (this.quiz.quizData.steps.length - 1)) {
            controls['userName'] = ['', Validators.required];
            controls['userDate'] = [null, Validators.required];
          }
          const stepForm = this._formBuilder.group(controls);
          this.quizForms.push(stepForm);
          stepForm.valueChanges.subscribe(v => this.recalculateVisibility());
        }
      );

      if (this.answersId) {
        this.assessmentService.getAssessmentResult(this.answersId).subscribe(r => {
          this.answersId = (r || {}).id;
          this.answers = JSON.parse((r || {}).answers || '{}');
          this.quiz.quizData.steps.map((step, stepId) => {
            const value = {};
            const stepForm = this.quizForms[stepId];
              step.items.map((item, itemId) => {
                if (item.type == 'question') {
                  if (item.hasPleaseExplain) {
                    value['r' + stepId + "_" + itemId + '_pleaseexplain'] = this.answers['r' + stepId + "_" + itemId + '_pleaseexplain'];
                  }
                  if (item.multiple) {
                    item.answers.map((answer, answerId) => {
                      value['r' + stepId + "_" + itemId + "_" + answerId] = (this.answers['r' + stepId + "_" + itemId] || []).indexOf(answerId) >= 0
                    })
                  } else {
                    value['r' + stepId + "_" + itemId] = (this.answers['r' + stepId + "_" + itemId] || [])[0];
                  }

                } else if (item.type == 'textQuestion') {
                  if (item.multiple) {
                    const val = {};
                    val['r' + stepId + "_" + itemId + "_0"] = '';
                    const a = this.answers['r' + stepId + "_" + itemId];
                    (this.answers['r' + stepId + "_" + itemId] || []).map((answer, answerId) => {
                      if (answerId > 0) {
                        this.addAnswer(stepId, 'r' + stepId + "_" + itemId);
                      }
                      val['r' + stepId + "_" + itemId + "_" + answerId] = (this.answers['r' + stepId + "_" + itemId] || [])[answerId] || '';
                    });
                    value['r' + stepId + "_" + itemId] = val;
                  } else {
                    value['r' + stepId + "_" + itemId] = this.answers['r' + stepId + "_" + itemId]
                  }
                } else if (item.type == 'attachment') {
                  this.files['r' + stepId + "_" + itemId] = this.answers['r' + stepId + "_" + itemId] || [];
                  this.files['r' + stepId + "_" + itemId].forEach(f => f.showLink = true);
                } else if (item.type === 'yesNoQuestion') {
                  const selectedAnswerId = this.answers[`r${stepId}_${itemId}`][0];
                  value[`r${stepId}_${itemId}`] = selectedAnswerId;
                  item.answers.forEach((answer, answerId) => {
                    value[`r${stepId}_${itemId}_${answerId}_pleaseexplain`] = [''];
                  });
                  if (selectedAnswerId !== null && selectedAnswerId !== undefined) {
                    value[`r${stepId}_${itemId}_${selectedAnswerId}_pleaseexplain`] = this.answers[`r${stepId}_${itemId}_pleaseexplain`] || '';
                  };
                }
              });
              if (stepId === (this.quiz.quizData.steps.length - 1) && r) {
                value['userName'] = r.userName;
                value['userDate'] = r.userDate;
              }
              stepForm.setValue(value);
            }
          );
          this.recalculateVisibility();
        });
      }
    }
  }

  ngOnInit() {
    this.tenantName = LoginHelper.getTenantName();
    const currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    this.canEdit = (currentUser.role & Role.AdvisorLead) != 0 ||
      (currentUser.role & Role.PrimaryAdvisorLead | Role.PlatformSupport) != 0 ||
      (currentUser.role & Role.Manager) != 0 ||
      (currentUser.role & Role.PrimaryManager) != 0 ||
      (currentUser.role & Role.KingAdmin) != 0 ||
      (currentUser.role & Role.Admin) != 0;
    this.canParticipate = this.canEdit || (currentUser.role & Role.User) != 0 || (currentUser.role & Role.AdvisorStaff) != 0

    this.route.params.subscribe(p => {
      this.assessmentId = p['assessmentId'];
      this.answersId = p['answerId'];
      this.initForm();
    })
    this.assessmentService.getAssessment(this.assessmentId).subscribe(t => {
      this.quiz = t;
      this.initForm()
    });
    this.assessmentService.getAllAssessments().subscribe(t => {
      this.assessments = t.filter(i => this.canParticipate || (i.assessmentUsers || []).find(u => u.userId == currentUser.userId));
    });
  }

  send(isFinished: boolean) {
    if ((!this.quizForms.find(f => !f.valid) || !isFinished) && (this.topForm.valid || this.topForm.controls.completionName.disabled)) {
      const result = {
        answers: {},
        userId: JSON.parse(sessionStorage.getItem('currentUser')).userId,
        assessmentId: this.assessmentId,
        id: this.answersId,
        userName: this.quizForms[this.quizForms.length - 1].value.userName,
        userDate: this.quizForms[this.quizForms.length - 1].value.userDate,
        completionName: this.topForm.controls.completionName.value,
        isFinished: isFinished,
      };
      this.quiz.quizData.steps.map((step, stepId) => {
        step.items.map((item, itemId) => {
          if (item.type == 'question') {
            result.answers['r' + stepId + "_" + itemId] = [];
            if (item.multiple) {
              item.answers.map((answer, answerId) => {
                if (this.quizForms[stepId].value['r' + stepId + "_" + itemId + "_" + answerId]) {
                  result.answers['r' + stepId + "_" + itemId].push(answerId);
                }
              })
            } else {
              result.answers['r' + stepId + "_" + itemId] = [this.quizForms[stepId].value['r' + stepId + "_" + itemId]];
            }
            if (item.hasPleaseExplain) {
              result.answers['r' + stepId + "_" + itemId + '_pleaseexplain'] = this.quizForms[stepId].value['r' + stepId + "_" + itemId + '_pleaseexplain'];
            }
          } else if (item.type == 'textQuestion') {
            if (item.multiple) {
              const group: any = this.quizForms[stepId].controls['r' + stepId + "_" + itemId];
              result.answers['r' + stepId + "_" + itemId] = group.list.map(i => group.controls['r' + stepId + '_' + itemId + '_' + i].value).filter(i => i);
            } else {
              result.answers['r' + stepId + "_" + itemId] = this.quizForms[stepId].value['r' + stepId + "_" + itemId];
            }
          } else if (item.type == 'yesNoQuestion') {
            console.log(this.answers);
            result.answers['r' + stepId + "_" + itemId] = [];
            let selectedAnswerId = this.quizForms[stepId].value[`r${stepId}_${itemId}`];
            if (selectedAnswerId !== null && selectedAnswerId !== undefined) {
              result.answers[`r${stepId}_${itemId}`] = [selectedAnswerId];
              result.answers[`r${stepId}_${itemId}_pleaseexplain`] = this.quizForms[stepId].value[`r${stepId}_${itemId}_${selectedAnswerId}_pleaseexplain`] || '';
            }
          } else if (item.type == 'attachment') {
            result.answers['r' + stepId + "_" + itemId] = this.files['r' + stepId + "_" + itemId] || [];
          }
        });
      });

      this.assessmentService.addAssessmentAnswers(result).subscribe((id) => {
        this.answersId = id;
        this.alertService.success("Survey successfully " + (isFinished ? 'submitted' : 'saved'));
      });
    } else {
      if (isFinished) {
        this.isValidated = true;
        let dialogRef = this.dialog.open(MessageComponent,
          {
            width: '250px',
            data: {title: '', text: 'Not all questions have been completed.', button: 'OK'}
          });
      }
    }
  }

  addAnswer(stepId, groupId) {
    const group: any = this.quizForms[stepId].controls[groupId];
    group.addControl(groupId + '_' + group.list.length, new FormControl(''));
    group.list.push(group.list.length);
  }

  public addAttachment(id, event) {
    let attachments = event.target.files;
    if (attachments.length > 0) {
      let file: File = attachments[0];
      this.assessmentService.uploadAttachment(file).subscribe(
        (names) => {
          const errorMessage = 'The control items were uploaded.';
          this.files[id] = this.files[id] || [];
          this.files[id].push(names);
          this.alertService.success(errorMessage);
        },
        (error) => {
          const errorMessage = 'An error occurred while upload control items.';
          this.alertService.error(errorMessage);
        });
    }
  }

  deleteAttachment(file, list) {
    list.splice(list.indexOf(file), 1);
  }

  recalculateVisibility() {
    this.isHidden = {};

    this.quiz.quizData.steps.map((step, stepId) => {
      step.items.map((item, itemId) => {
        if (item.answers) {
          item.answers.map((answer, answerId) => {
            if (answer.hideIfSelected) {
              answer.hideIfSelected.forEach(h => {
                if (!item.multiple && this.quizForms[stepId].value[`r${stepId}_${itemId}`] == answerId
                  || item.multiple && this.quizForms[stepId].value[`r${stepId}_${itemId}_${answerId}`] == true) {
                  const parts = h.split('_');
                  if (parts.length == 1) {
                    parts.unshift(stepId);
                  }
                  this.isHidden[parts[0] * 1] = this.isHidden[parts[0] * 1] || {};
                  this.isHidden[parts[0] * 1][parts[1] * 1] = true;
                }
              });
            }
          })
        }
      });
    });
    this.quiz.quizData.steps.map((step, stepId) => {
      step.items.map((item, itemId) => {
        let hasChanges: boolean;
        const questionControl = this.quizForms[stepId].controls['r' + stepId + '_' + itemId];
        if (questionControl) {
          if (this.isHidden[stepId] && this.isHidden[stepId][itemId]) {
            hasChanges = questionControl.validator != null;
            questionControl.clearValidators();
            if (hasChanges) {
              questionControl.updateValueAndValidity({emitEvent: false});
            }
          } else {
            hasChanges = !questionControl.validator;
            if (!this.notRequired['r' + stepId + "_" + itemId]) {
              questionControl.setValidators([Validators.required]);
            }
            if (hasChanges) {
              questionControl.updateValueAndValidity({emitEvent: false});
            }
          }
        }
      });
    });
  }

  openHistory() {
    this.assessmentService.getAssessmentVersionList(this.assessmentId).subscribe(r => {
      r.forEach(a => a.unfinishedAnswers.forEach(c => c.results = JSON.parse(c.answers)));
      let config: MatDialogConfig = {
        panelClass: 'custom-overlay-pane-class',
        width: '98%',
        height: '90vh',
        data: {
          quiz: this.quiz,
          answers: r,
          assessmentId: this.assessmentId,
        }
      };

      const dialogRef = this.dialog.open(AssessmentUserAnswersComponent, config);
    });
  }

  protected readonly encodeURIComponent = encodeURIComponent;
}
